import useMinWidth from './useMinWidth'

export function useIsMinWidthLg() {
  return useMinWidth('lg')
}
